import { forwardRef, useState } from 'react';
import { TextField, InputAdornment, IconButton } from '@mui/material';
import type { TextFieldProps } from '@mui/material';
import VisibilityIcon from '@mui/icons-material/Visibility';
import VisibilityOffIcon from '@mui/icons-material/VisibilityOff';

// A password TextField with a built-in show/hide toggle. Drop-in replacement for
// any <TextField type="password"> — forwards every TextField (and react-hook-form
// field) prop unchanged, and manages its own reveal state. The `type` prop is
// controlled here, so callers should NOT pass it.
const PasswordField = forwardRef<HTMLDivElement, TextFieldProps>(
  function PasswordField(props, ref) {
    const [show, setShow] = useState(false);
    return (
      <TextField
        {...props}
        ref={ref}
        type={show ? 'text' : 'password'}
        InputProps={{
          ...props.InputProps,
          endAdornment: (
            <InputAdornment position="end">
              <IconButton
                aria-label={show ? 'Hide password' : 'Show password'}
                onClick={() => setShow((s) => !s)}
                onMouseDown={(e) => e.preventDefault()}
                edge="end"
                size="small"
                tabIndex={-1}
                sx={{ color: 'text.secondary' }}
              >
                {show ? (
                  <VisibilityOffIcon fontSize="small" />
                ) : (
                  <VisibilityIcon fontSize="small" />
                )}
              </IconButton>
            </InputAdornment>
          )
        }}
      />
    );
  }
);

export default PasswordField;
